import { MercerJobType } from '../../mercer/enums/mercer-job-type.enum';
import { MercerJobProfile } from '../../mercer/models/mercer-job-profile.model';

export const JOB_PROFILE_CONFIG: MercerJobProfile[] = [
  {
    type: MercerJobType.Family,
    icon: 'account_tree',
    title: '',
    description: '',
    correlatingMercerDataTitleKey: 'family',
    correlatingMercerDataDescriptionKey: 'familyDescription'
  },
  {
    type: MercerJobType.SubFamily,
    icon: 'group_work',
    title: '',
    description: '',
    correlatingMercerDataTitleKey: 'subFamily',
    correlatingMercerDataDescriptionKey: 'subFamilyDescription'
  },
  {
    type: MercerJobType.Specialization,
    icon: 'star',
    title: '',
    description: '',
    correlatingMercerDataTitleKey: 'specialization',
    correlatingMercerDataDescriptionKey: 'specializationDescription'
  },
  {
    type: MercerJobType.CareerStream,
    icon: 'work',
    title: '',
    description: '',
    correlatingMercerDataTitleKey: 'careerStream',
    correlatingMercerDataDescriptionKey: 'careerStreamDescription'
  },
  {
    type: MercerJobType.CareerLevel,
    icon: 'diamond',
    title: '',
    description: '',
    correlatingMercerDataTitleKey: 'careerLevel',
    correlatingMercerDataDescriptionKey: 'careerLevelDescription'
  }
];
